import * as types from '../constants/ActionTypes';
import update from 'immutability-helper';

const initialState = {  
    language: "el"
};

export default function setLanguage (state = initialState, action) {
    switch (action.type) {
        case types.CHANGE_LANGUAGE:
            return update(state, {language: {$set: action.language} })
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_translation.js